module.exports = __webpack_public_path__ + "img/reservations-followed-add.844f65cb.svg";